import Grid from './grid'

Grid.install = vue => {
  vue.component(Grid.name, Grid)
}

export default Grid
